 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"Components-dashboardcreation-dashboardcreation-module":"Components-dashboardcreation-dashboardcreation-module","Components-ganttchart-ganttchart-module":"Components-ganttchart-ganttchart-module","Components-login-login-module":"Components-login-login-module","Components-macro-macro-module":"Components-macro-macro-module","Components-macroentrys-macroentrys-module":"Components-macroentrys-macroentrys-module","Components-macromachine-macromachine-module":"Components-macromachine-macromachine-module","Components-notifications-notifications-module":"Components-notifications-notifications-module","Components-production-production-module":"Components-production-production-module","Components-reflect-reflect-module":"Components-reflect-reflect-module","Nav-sidebar-sidebar-module":"Nav-sidebar-sidebar-module","common":"common","Components-alarm-alarm-module":"Components-alarm-alarm-module","Components-color-color-module":"Components-color-color-module","Components-component-component-module":"Components-component-component-module","Components-eff-report-eff-report-module":"Components-eff-report-eff-report-module","Components-idle-reasons-idle-reasons-module":"Components-idle-reasons-idle-reasons-module","Components-idlereasoncapture-idlereasoncapture-module":"Components-idlereasoncapture-idlereasoncapture-module","Components-logdetails-logdetails-module":"Components-logdetails-logdetails-module","Components-loghistory-loghistory-module":"Components-loghistory-loghistory-module","Components-machine-registration-machine-registration-module":"Components-machine-registration-machine-registration-module","Components-operator-registration-operator-registration-module":"Components-operator-registration-operator-registration-module","Components-quality-quality-module":"Components-quality-quality-module","Components-reason-lmw-reason-lmw-module":"Components-reason-lmw-reason-lmw-module","Components-shift-shift-module":"Components-shift-shift-module","Components-user-management-user-management-module":"Components-user-management-user-management-module","default~Components-alarmreports-alarmreports-module~Components-andon-dashboard-andon-dashboard-modul~5de4a62c":"default~Components-alarmreports-alarmreports-module~Components-andon-dashboard-andon-dashboard-modul~5de4a62c","Components-chart-chart-module":"Components-chart-chart-module","Components-machine-lmw-machine-lmw-module":"Components-machine-lmw-machine-lmw-module","Components-oee-oee-module":"Components-oee-oee-module","default~Components-alarmreports-alarmreports-module~Components-andon-dashboard-andon-dashboard-modul~8bc1952c":"default~Components-alarmreports-alarmreports-module~Components-andon-dashboard-andon-dashboard-modul~8bc1952c","Components-overallchart-overallchart-module":"Components-overallchart-overallchart-module","Components-spindle-spindle-module":"Components-spindle-spindle-module","Components-trendchart-trendchart-module":"Components-trendchart-trendchart-module","Components-sdashboard-sdashboard-module":"Components-sdashboard-sdashboard-module","Components-oee-dashboard-oee-dashboard-module":"Components-oee-dashboard-oee-dashboard-module","Components-andon-dashboard-andon-dashboard-module":"Components-andon-dashboard-andon-dashboard-module","Components-dashboard-dashboard-module":"Components-dashboard-dashboard-module","Components-dashboardline-dashboardline-module":"Components-dashboardline-dashboardline-module","Components-kpi-dashboard-kpi-dashboard-module":"Components-kpi-dashboard-kpi-dashboard-module","Components-main-dashboard-main-dashboard-module":"Components-main-dashboard-main-dashboard-module","Components-maintenancedashboard-maintenancedashboard-module":"Components-maintenancedashboard-maintenancedashboard-module","Components-maintenancedb-maintenacedb-module":"Components-maintenancedb-maintenacedb-module","Components-maintenancereport-maintenancereport-module":"Components-maintenancereport-maintenancereport-module","Components-mdashboard-mdashboard-module":"Components-mdashboard-mdashboard-module","Components-new-new-module":"Components-new-new-module","Components-newdash-newdash-module":"Components-newdash-newdash-module","Components-rabwin-dashboard-rabwin-dashboard-module":"Components-rabwin-dashboard-rabwin-dashboard-module","Components-settings-settings-module":"Components-settings-settings-module","Components-sup-dashboard-sup-dashboard-module":"Components-sup-dashboard-sup-dashboard-module","Components-tv-tv-module":"Components-tv-tv-module","default~Components-alarmreports-alarmreports-module~Components-balloon-report-balloon-report-module~~611ee956":"default~Components-alarmreports-alarmreports-module~Components-balloon-report-balloon-report-module~~611ee956","Components-comparechart-comparechart-module":"Components-comparechart-comparechart-module","default~Components-alarmreports-alarmreports-module~Components-balloon-report-balloon-report-module~~9aa54a13":"default~Components-alarmreports-alarmreports-module~Components-balloon-report-balloon-report-module~~9aa54a13","Components-overallcomparechart-overallcomparechart-module":"Components-overallcomparechart-overallcomparechart-module","Components-trendingchart-trending-module":"Components-trendingchart-trending-module","default~Components-alarmreports-alarmreports-module~Components-report-idle-report-idle-module":"default~Components-alarmreports-alarmreports-module~Components-report-idle-report-idle-module","Components-alarmreports-alarmreports-module":"Components-alarmreports-alarmreports-module","Components-idle-reason-idle-reason-module":"Components-idle-reason-idle-reason-module","Components-idle-report-idle-report-module":"Components-idle-report-idle-report-module","Components-macstatuschart-macstatuschart-module":"Components-macstatuschart-macstatuschart-module","Components-report-idle-report-idle-module":"Components-report-idle-report-idle-module","Components-efficiency-efficiency-module":"Components-efficiency-efficiency-module","Components-overall-report-overall-report-module":"Components-overall-report-overall-report-module","Components-report-report-module":"Components-report-report-module","Components-balloon-report-balloon-report-module":"Components-balloon-report-balloon-report-module","Components-companydashboard-companydashboard-module":"Components-companydashboard-companydashboard-module","Components-cycle-cycle-module":"Components-cycle-cycle-module","Components-mefficiency-mefficiency-module":"Components-mefficiency-mefficiency-module","Components-report-allocations-report-allocations-module":"Components-report-allocations-report-allocations-module","Components-reportnew-reportnew-module":"Components-reportnew-reportnew-module","Components-reports-all-reports-all-module":"Components-reports-all-reports-all-module","Components-dashboardcreation1-dashboardcreation1-module":"Components-dashboardcreation1-dashboardcreation1-module","Components-insights-insights-module":"Components-insights-insights-module","Components-newquality-newquality-module":"Components-newquality-newquality-module","Components-notification-report-notification-report-module":"Components-notification-report-notification-report-module","canvg":"canvg","dompurify":"dompurify","html2canvas":"html2canvas"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
